import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";

// //////////////////
// Action Creators //
// //////////////////

export const LimpiarPrestacion = () => ({
  type: "NUEVA_PREST/LIMPIAR_PRESTACION",
});

export const ConfirmacionGuardadoAgregacion = (aceptaGuardadoModal) => ({
  type: "NUEVA_PREST/CONFIRMACION_GUARDADO_AGREGACION",
  aceptaGuardadoModal,
});

export const CambiarCodPrestacion = (codigoPrestacionPrestador) => ({
  type: "NUEVA_PREST/CAMBIAR_CODIGO_PRESTACION",
  codigoPrestacionPrestador,
});

export const CambiarTipoPrestacion = (tipoPrestacion, glosaPrestacion) => ({
  type: "NUEVA_PREST/CAMBIAR_CODIGO_TIPOPRESTACION",
  tipoPrestacion,
  glosaPrestacion,
});

export const CambiarGuarismo = (pabellonPrestacion) => ({
  type: "NUEVA_PREST/CAMBIAR_CODIGO_GUARISMO",
  pabellonPrestacion,
});

export const CambiarUnidadGrilla = (value, error, tipoAtencion, rutArancel, centroAtencion) => ({
  type: "NUEVA_PREST/CAMBIAR_UNIDAD_GRILLA",
  value,
  error,
  tipoAtencion,
  rutArancel,
  centroAtencion,
});

export const CambiarUnidadReplicar = (tipoUnidad) => ({
  type: "NUEVA_PREST/CAMBIAR_UNIDAD_REPLICAR",
  tipoUnidad,
});

export const CambiarCheckRows = (checked, rutArancel, centroAtencion) => ({
  type: "NUEVA_PREST/CHECK_ROWS",
  checked,
  rutArancel,
  centroAtencion,
});

export const CambiarGlosaPrestacionPrestador = (glosaPrestacionPrestador) => ({
  type: "NUEVA_PREST/CAMBIAR_GLOSA_PRESTACION_PRESTADOR",
  glosaPrestacionPrestador,
});

export const CambiarInicioVigencia = (inicioVigenciaArancel, error) => ({
  type: "NUEVA_PREST/CAMBIAR_INICIO_VIGENCIA",
  inicioVigenciaArancel,
  error,
});

export const CambiarPertenenciaFonasa = (pertenenciaFonasa) => ({
  type: "NUEVA_PREST/CAMBIAR_PERTENENCIA_FONSA",
  pertenenciaFonasa,
});

export const CambiarCodFonasa = (codigoFonasa) => ({
  type: "NUEVA_PREST/CAMBIAR_CODIGO_FONASA",
  codigoFonasa,
});

export const CambiarItemImed = (itemImed, error) => ({
  type: "NUEVA_PREST/CAMBIAR_ITEM_IMED",
  itemImed,
  error,
});

export const CambiarTipoProfesional = (tipoProfesional) => ({
  type: "NUEVA_PREST/CAMBIAR_TIPO_PROFESIONAL",
  tipoProfesional,
});

export const GuardarValorPrestaciones = (value, error, tipoAtencion, rutArancel, centroAtencion) => ({
  type: "NUEVA_PREST/GUARDAR_VALOR_PRESTACIONES",
  value,
  error,
  tipoAtencion,
  rutArancel,
  centroAtencion,
});

export const GuardarArbolInicial = (tiposArancel, centrosAtencion) => ({
  type: "NUEVA_PREST/GUARDAR_ARBOL_INICIAL",
  tiposArancel,
  centrosAtencion,
});

export const cargarValorMaxPrestacion = (valorMaxPres) => ({
  type: "NUEVA_PREST/CARGAR_VALOR_MAX_PRES",
  valorMaxPres,
});

export const CambiarMontoAmbulatorio = (montoAmbulatorio) => ({
  type: "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_AMBULATORIO",
  montoAmbulatorio,
});

export const CambiarMontoAmbulatorioError = (montoAmbulatorioError) => ({
  type: "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_AMBULATORIO_ERROR",
  montoAmbulatorioError,
});

export const CambiarMontoHospitalario = (montoHospitalario) => ({
  type: "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_HOSPITALARIO",
  montoHospitalario,
});

export const CambiarMontoHospitalarioError = (montoHospitalarioError) => ({
  type: "NUEVA_PREST/EDIT_MOD/CAMBIAR_MONTO_HOSPITALARIO_ERROR",
  montoHospitalarioError,
});

export const DisplayErrorText = (Errors) => ({
  type: "NUEVA_PREST/EDIT_MOD/DISPLAY_ERROR_TEXT",
  Errors,
});

export const LimpiarErroresGrilla = () => ({
  type: "NUEVA_PREST/LIMPIAR_ERROR_GRILLA_UNSELECT",
});

export const SetValidaCodIsapreFonasa = (valid, codigoGlosa, hasMinLength) => ({
  type: "NUEVA_PREST/SET_VALIDACION_CODIGO_FONASA",
  valid,
  codigoGlosa,
  hasMinLength,
});

export const LimpiarCodIsapreFonasa = (error) => ({
  type: "NUEVA_PREST/CLEAR_CODIGO_FONASA",
  error,
});

export const LoadingValidaCodIsapreFonasa = (isLoad) => ({
  type: "NUEVA_PREST/LOADING_VALIDACION_CODIGO_FONASA",
  isLoad,
});

export const ValidarGuarismo = (validar) => ({
  type: "NUEVA_PREST/VALIDAR_GUARISMO",
  validar,
});

export const CargarTiposArancelAll = (tiposArancel) => ({
  type: "NUEVA_PREST/CARGAR_TIPOS_ARANCEL",
  tiposArancel,
});

export const AddErrorToPrestacion = (idArrPrestacion, unidad, tipoAtencion) => ({
  type: "NUEVA_PREST/ADD_ERROR_PRESTACION",
  idArrPrestacion,
  unidad,
  tipoAtencion,
});

export const RemoveErrorToPrestacion = idArrPrestacion => ({
  type: 'NUEVA_PREST/REMOVE_ERROR_PRESTACION',
  idArrPrestacion,
});

export const ChangeFonasaInAllPrests = () => ({
  type: "NUEVA_PREST/CHANGE_FONASA_IN_ALL_PRESTS",
});

export const CheckForFonasaErrorsInPrests = () => ({
  type: 'NUEVA_PREST/CHECK_FOR_FONASA_ERRORS_IN_PRESTS',
});

export const CleanErrorsInPrests = () => ({
  type: 'NUEVA_PREST/CLEAN_ERRORS_IN_PRESTS',
});

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const OpenConfirmacionGuardadoAgregacion = () => (dispatch) => {
  dispatch(ConfirmacionGuardadoAgregacion(true));
};

export const CloseConfirmacionGuardadoAgregacion = () => (dispatch) => {
  dispatch(ConfirmacionGuardadoAgregacion(false));
};

export const obtenerValorMaxPrestacion = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/parametros/ValorMaxPrestacion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("obtenerValorMaxPrestacion", json);
        dispatch(cargarValorMaxPrestacion(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("obtenerValorMaxPrestacion", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener el valor máximo de la prestación:",
        error,
      ));
    });
};

export const ValidarPrestacionExiste = (prestValidar, callback) => (dispatch) => {
  const globalState = store.getState().global;

  const promises = [];
  prestValidar.forEach((prest) => {
    const params = {
      RutArancel: prest.rutArancel,
      CentroMedico: prest.centroAtencion,
      CodPrestacionPrestador: prest.codigoPrestacionPrestador,
      TipoAtencion: prest.tipoAtencion,
      CodProfesional: prest.tipoProfesional,
      Isapre: globalState.isapre,
      InicioVigencia: prest.inicioVigenciaArancel,
      //TipoPrestacion: prest.tipoPrestacion,
      token: globalState.token,
    };

    promises.push(new Promise((resolve) => {
      fetch(`${apiConfig.apiUri}/v1/prestaciones/validacionexiste/`, {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          // Authorization: localStorage.getItem('id_token'),
        },
        credentials: "same-origin",
        body: JSON.stringify(params),
      })
        .then((response) => {
          if (!response.ok) { throw response; }
          return response.json();
        })
        .then((json) => {
          if (json) {
            //trace.information("ValidarPrestacionExiste", json);
            resolve(json);
          } else {
            throw json;
          }
        })
        .catch((error) => {
          trace.error("ValidarPrestacionExiste", error);
          dispatch(ErrorSnacktOpen(
            "Error al validar prestaciones existentes:",
            error,
          ));
        });
    }));
  });

  Promise.all(promises)
    .then((responses) => {
      const prestacionesExistentes = [];
      const prestacionesNoExistentes = [];
      let error = '';
      let mensaje = '';
      responses.forEach((response) => {
        if (response.Existe === "S") {
          prestacionesExistentes.push({
            RutArancel: response.RutArancel,
            CentroMedico: response.CentroMedico,
            TipoAtencion: response.TipoAtencion,
          });
        } else if (response.Existe === "N") {
          prestacionesNoExistentes.push({
            RutArancel: response.RutArancel,
            CentroMedico: response.CentroMedico,
            TipoAtencion: response.TipoAtencion,
          });
        } else {
          error = 'S';
          mensaje = response;
        }
      });
      if (error === 'S') {
        trace.error("ValidarPrestacionExiste", mensaje);
        dispatch(ErrorSnacktOpen(
          "Error al validar prestaciones existentes:",
          mensaje,
        ));
      } else {
        callback(prestacionesExistentes, prestacionesNoExistentes);
      }
    });
};

export const validaCodIsapreFonasa = () => (dispatch) => {
  const globalState = store.getState().global;
  const nuevaPrestacionFormState = store.getState().nuevaPrestacionForm;
  const params = {
    CodFonasa: nuevaPrestacionFormState.detallePrestacion.codigoFonasa,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/prestaciones/validaCodIsapreFonasa/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("validaCodIsapreFonasa", json);
      let codigoValido = false;
      let codigoGlosa = "";
      if (json && json.Existe && json.Existe === "S") {
        codigoValido = true;
        codigoGlosa = json.Glosa;
      }
      dispatch(SetValidaCodIsapreFonasa(codigoValido, codigoGlosa, !(nuevaPrestacionFormState.detallePrestacion.codigoFonasa.length < 6)));
      dispatch(LoadingValidaCodIsapreFonasa(false));
    })
    .catch((error) => {
      trace.error("validaCodIsapreFonasa", error);
      dispatch(ErrorSnacktOpen(
        "Error al válidar código fonasa:",
        error,
      ));
    });
};

export const ObtenerTiposArancelAll = () => (dispatch) => {
  const globalState = store.getState().global;

  // centroAtencion = null : Obtiene todos los tipos de arancel del prestador
  const params = {
    RutPrest: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/aranceles/prestador/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("ObtenerTiposArancelAll", json);
        dispatch(CargarTiposArancelAll(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("ObtenerTiposArancelAll", error);
      dispatch(ErrorSnacktOpen(
        "Error al obtener los tipos de arancel:",
        error,
      ));
    });
};
